var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiteriaIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75949 16.0474L6.24385 15.4659C5.38706 14.4998 5.24467 13.0937 5.89035 11.9754L6.72799 10.5245C7.37363 9.40619 8.66242 8.8265 9.92749 9.08537L10.689 9.24118C11.394 9.38542 12.1273 9.2664 12.7505 8.90661V8.90661C13.3736 8.54683 13.8434 7.97122 14.0709 7.28859L14.3167 6.55129C14.7251 5.32628 15.8715 4.5 17.1628 4.5H18.8383C20.1295 4.5 21.2759 5.32628 21.6843 6.55129L21.9301 7.28859C22.1576 7.97121 22.6274 8.54681 23.2505 8.9066V8.9066C23.8737 9.2664 24.607 9.38542 25.312 9.24117L26.0735 9.08535C27.3386 8.82648 28.6274 9.40617 29.273 10.5245L30.1108 11.9754C30.7564 13.0938 30.614 14.4998 29.7573 15.4659L29.2416 16.0474C28.7642 16.5858 28.5005 17.2804 28.5005 18V18C28.5005 18.7196 28.7641 19.4142 29.2416 19.9526L29.7572 20.5341C30.614 21.5002 30.7564 22.9063 30.1107 24.0246L29.273 25.4756C28.6273 26.5939 27.3386 27.1736 26.0735 26.9147L25.3117 26.7588C24.6068 26.6146 23.8735 26.7336 23.2505 27.0933V27.0933C22.6273 27.4531 22.1576 28.0287 21.93 28.7113L21.6842 29.4487C21.2759 30.6737 20.1295 31.5 18.8382 31.5H17.1628C15.8715 31.5 14.7251 30.6737 14.3167 29.4487L14.0709 28.7112C13.8434 28.0286 13.3736 27.453 12.7505 27.0933V27.0933C12.1274 26.7335 11.3941 26.6145 10.6893 26.7588L9.92749 26.9146C8.66242 27.1735 7.37363 26.5938 6.72799 25.4755L5.89026 24.0245C5.24458 22.9062 5.38697 21.5002 6.24376 20.534L6.7594 19.9526C7.23683 19.4142 7.50048 18.7196 7.50049 18V18C7.50051 17.2804 7.2369 16.5858 6.75949 16.0474Z",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4.5,
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiteriaIcon1);
export default __webpack_public_path__ + "static/media/сriteria-icon-1.7fef8be071b18f2c377160b5be6f9383.svg";
export { ForwardRef as ReactComponent };